import { t } from "i18next";


export const contactUsLink = "https://www.quidelortho.com/global/en/contact-us";

export const spinnerStyle = {
    "margin": "100px 0",
    "display": "flex",
    "justifyContent": "center"
  }


export const getOrderTotalsData = (orderTotals) => {
    return {
        title: t('orderTotals'),
        currency: orderTotals?.currency?.toString()?.toUpperCase() || "",
        data: [
            {
                label: t('orderValue'),
                value: orderTotals?.orderValue || ""
            },
            {
                label: t('taxes'),
                value: orderTotals?.orderTax || ""
            },
            {
                label: t('shippingAndHandling'),
                value: orderTotals?.orderShip || ""
            },
            {
                label: t('orderTotal'),
                value: orderTotals?.orderTotal || ""
            }
        ],
        color: "lightsalmon"
    }
}